// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — ZoneInfo.classic.js, новая — ZoneInfo.cp.js
import { isCp } from 'libs/design';
import * as classic from './ZoneInfo.classic';
import * as cp from './ZoneInfo.cp';

export const ZoneInfo = isCp ? cp.ZoneInfo : classic.ZoneInfo;
